import { LicenseInfo } from '@mui/x-data-grid-pro';

const licenseKey = process.env.REACT_APP_MUI_X_LICENSE_KEY;

if (licenseKey) {
  LicenseInfo.setLicenseKey(licenseKey);
}
